// extracted by mini-css-extract-plugin
export default {"container":"MenusAndDrinksNav_container__4V96C","nav":"MenusAndDrinksNav_nav__aOIC8","nav-btn":"MenusAndDrinksNav_nav-btn__OFdj7","active":"MenusAndDrinksNav_active__fgrn4"};